<div class="sp-order-details-general__grid sp-min-height__full">
  <app-order-details-general-info
    *ngIf="!is_read_running"
    class="sp-order-details-general__info"
    [order]="order"></app-order-details-general-info>

  <app-order-details-general-payment
    *ngIf="!is_read_running"
    [order]="order"></app-order-details-general-payment>

  <app-order-details-general-tax-deduction
    *ngIf="!is_read_running"
    [order]="order"></app-order-details-general-tax-deduction>

  <app-order-details-general-company
    *ngIf="!is_read_running"
    [order]="order"></app-order-details-general-company>

  <app-order-details-general-buyer
    *ngIf="!is_read_running"
    [order]="order"></app-order-details-general-buyer>

  <app-loading
    *ngIf="is_read_running"
    class="sp-order-details-general__info sp-order-details-general__loading"></app-loading>

  <app-loading
    *ngIf="is_read_running"
    class="sp-order-details-general__loading"></app-loading>

  <app-loading
    *ngIf="is_read_running"
    class="sp-order-details-general__loading"></app-loading>

  <app-loading
    *ngIf="is_read_running"
    class="sp-order-details-general__loading"></app-loading>

  <app-loading
    *ngIf="is_read_running"
    class="sp-order-details-general__loading"></app-loading>
</div>
